import {BottomStickyNavbarContainerDefaultBox} from "./bottom-sticky-navbar-container.default.box";

export const BottomStickyNavbarContainerBox = BottomStickyNavbarContainerDefaultBox;
